import './instance';

// register create function for bundleid
Oskari.bundle('inspire', () => Oskari.clazz.create('Oskari.mapframework.bundle.inspire.instance'));